export * from './lib/kanzi-location.module';

// NgRx State (DEPRECATED - migrating to TanStack Query)
export * from './lib/+state/locations.reducer';
export * from './lib/+state/locations.actions';
export * from './lib/+state/locations.selectors';

// TanStack Query (NEW - preferred approach)
export * from './lib/queries';